import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AccessDomain } from '@huge-monorepo/hip/domain';
import jwt_decode from 'jwt-decode';
import { User } from '@huge-monorepo/hip/domain';
import { Router } from '@angular/router';
import { DialogService } from './dialog.service';

export class LoginRequest {
  constructor(
    public ID: number,
    public UserID: number,
    public UID: number,
    public Email: string,
    public Name: string,
    public Token: string,
    public UserRights: any[],
    public IsContractorLogin?: boolean,
    public ContractorID?: number,
    public ImpersonatedUserRights?: any[],
    public ImpersonatedUser?: User,
  ) { }
}

@Injectable({
  providedIn: 'root',
})
export class UserRightsService {
  private storage = window.localStorage;

  private RIGHTS: string = 'STHGIRSSECCA';
  private RightsObject = new BehaviorSubject({});
  currentRightsObject = this.RightsObject.asObservable();

  private USER: string = 'IUDHAWUMNSCEEEEHDWY';
  private UserObject: BehaviorSubject<LoginRequest>;
  // currentUserObject = this.UserObject.asObservable();
  // private tries = 0;

  constructor(private router: Router, private dialogService: DialogService) {
    let rights = this.storage.getItem(this.RIGHTS);
    if (rights != null) {
      this.RightsObject.next(JSON.parse(rights));
    }

    let user = this.storage.getItem(this.USER);
    if (user != null) {
      let parsedUser = JSON.parse(user) as LoginRequest;
      this.UserObject = new BehaviorSubject<LoginRequest>(parsedUser);
      this.UserObject.next(parsedUser);
    }
  }

  // Change Rights
  SetRights(values: AccessDomain[]) {
    // console.log(values);
    let obj = {};
    values.forEach((domain) => {
      let roleObject = {
        Domain: domain,
      };
      if (domain.Roles != null) {
        domain.Roles.forEach((role) => {
          roleObject[role.Description] = role;
        });
      }
      obj[domain.Description] = roleObject;
    });
    this.storage.setItem(this.RIGHTS, JSON.stringify(obj));
    this.RightsObject.next(obj);
  }

  HasAccess(domain, roles: string[]): boolean {
    if (this.RightsObject == null) {
      console.error('No rights set');
      return false;
    }
    if (this.RightsObject.value['HIP'] != null) {
      if (this.RightsObject.value['HIP']['Super User'] != null) {
        return true;
        // return false;
      } else if (this.RightsObject.value['HIP']['Registered'] != null) {
        // console.log("Access Denied to the Registered User");
        return false;
      }
    }
    let accessDomain = this.RightsObject.value[domain] as AccessDomain;
    if (accessDomain == null) {
      console.warn('Area key not found', domain);
      return false;
    }

    let valid: boolean = false;
    roles.forEach((role) => {
      if (accessDomain[role] != null) {
        valid = true;
      }
    });
    return valid;
  }

  IsRegistered(): boolean {
    if (this.RightsObject != null && this.RightsObject.value['HIP'] != null && this.RightsObject.value['HIP']['Registered'] != null) {
      return true;
    }
    return false;
  }

  IsImpersonating(): User | null {
    if (this.UserObject != null) {
      return this.UserObject.value.ImpersonatedUser;
    }
    return null;
  }

  ClearRights() {
    this.storage.removeItem(this.RIGHTS);
    this.RightsObject = new BehaviorSubject({});
    this.currentRightsObject = this.RightsObject.asObservable();
  }

  IsLoggedIn() {
    // console.log(this.UserObject, this.USER);
    // if (this.UserObject == null) {
    //   let user = this.storage.getItem(this.USER);
    //   // console.log(user);
    //   if (user != null) {
    //     let parsedUser = JSON.parse(user) as LoginRequest;
    //     this.UserObject = new BehaviorSubject<LoginRequest>(parsedUser);
    //     this.UserObject.next(parsedUser);
    //     // console.log(this.UserObject);
    //   }
    // }

    if (this.UserObject != null) {
      if (this.UserObject.value.Token != null && this.UserObject.value.Token != '' && this.UserObject.value.UID > 0) {
        let expirationTime = this.getExpiryTimeFromToken(this.UserObject.value.Token);
        // console.log(this.getTimeDifference(expirationTime));
        if (this.getTimeDifference(expirationTime) > 0) {
          return true;
        }
      }
    }
    return false;
  }

  isContractorLoggedIn() {
    if (this.UserObject != null) {
      if (this.UserObject.value.Token != null && this.UserObject.value.Token != '' && this.UserObject.value.UID > 0 && this.UserObject.value.IsContractorLogin) {
        let expirationTime = this.getExpiryTimeFromToken(this.UserObject.value.Token);
        // console.log(this.getTimeDifference(expirationTime));
        if (this.getTimeDifference(expirationTime) > 0) {
          return true;
        }
      }
    }
    return false;
  }

  UpdateToken(newToken: string) {
    if (this.UserObject != null) {
      this.UserObject.value.Token = newToken;
      this.storage.setItem(this.USER, JSON.stringify(this.UserObject.value));
    }
  }

  GetToken(): string {
    if (this.UserObject != null && this.UserObject.value.Token) {
      return this.UserObject.value.Token;
    }
    return null;
  }

  GetEmail(): string {
    if (this.UserObject != null && this.UserObject.value.Email) {
      return this.UserObject.value.Email;
    }
    return null;
  }

  calculateRefreshTime(): number {
    if (this.UserObject == null) {
      return 0;
    }
    let timeBefore = 30000; // 30 seconds in Milliseconds
    return this.getTimeDifference(this.getExpiryTimeFromToken(this.UserObject.value.Token)) - timeBefore;
  }

  getExpiryTimeFromToken(token: string): Date {
    var decoded = jwt_decode(token);
    console.log('Decoded JWT token:', decoded);
    const d = new Date(0);
    d.setUTCSeconds(decoded['exp']);
    return d;
  }

  getTimeDifference(expire: Date): number {
    const now = new Date(Date.now());
    return Math.abs(expire.getTime() - now.getTime());
  }

  GetUserID(): number {
    if (this.UserObject != null) {
      return this.UserObject.value.UserID;
    }
    return null;
  }

  GetUID(): number {
    if (this.UserObject != null) {
      return this.UserObject.value.UID;
    }
    return null;
  }

  saveDataToPersist() {
    let arr = [];
    const keysToRemember = ['releaseNoteVersion'];

    keysToRemember.forEach((element) => {
      if (localStorage.getItem(element)) arr.push([element, localStorage.getItem(element)]);
    });

    return arr;
  }

  setPersistentData(keys: any[]) {
    if (!keys) return;

    keys.forEach((element) => {
      if (element.length == 2) {
        localStorage.setItem(element[0], element[1]);
      }
    });
  }

  Logout() {
    console.trace();
    let keysToRetain = this.saveDataToPersist();
    localStorage.clear();
    this.ClearRights();
    this.router.navigate(['/']);
    this.UserObject = null;
    this.storage.clear();
    this.dialogService.DeRegisterAll();
    this.setPersistentData(keysToRetain);
  }

  Login(request: LoginRequest): Boolean {
    if (request == null || request.UID == 0 || request.Token == '') {
      return false;
    }

    // Determine if this user originally logged in as a contractor
    request.IsContractorLogin = request.ContractorID != null && request.ContractorID > 0;

    this.storage.setItem(this.USER, JSON.stringify(request));
    if (this.UserObject == null) {
      this.UserObject = new BehaviorSubject<LoginRequest>(request);
    }
    this.UserObject.next(request);

    return true;
  }

  GetUserName(): string | null {
    if (this.UserObject != null && this.UserObject.value != null) {
      return this.UserObject.value.Name;
    }
    return null;
  }

  GetUserRights(): any[] {
    if (this.UserObject != null && this.UserObject.value != null) {
      return this.UserObject.value.UserRights;
    }
    return null;
  }

  StartImpersonation(impersonationUser: User, impersonationUserRoles: any[]) {
    if (this.UserObject != null) {
      let user = this.storage.getItem(this.USER);
      if (user != null) {
        let parsedUser = JSON.parse(user) as LoginRequest;
        parsedUser.ImpersonatedUser = impersonationUser;
        parsedUser.ImpersonatedUserRights = impersonationUserRoles;
        this.UserObject = new BehaviorSubject<LoginRequest>(parsedUser);
        this.UserObject.next(parsedUser);
        this.storage.setItem(this.USER, JSON.stringify(parsedUser));
      }
      this.ClearRights();
      this.SetRights(impersonationUserRoles);
      this.router.navigate(['/']);
    }
  }

  StopImpersonation() {
    if (this.UserObject != null && this.UserObject.value != null) {
      let user = this.storage.getItem(this.USER);
      if (user != null) {
        let parsedUser = JSON.parse(user) as LoginRequest;
        parsedUser.ImpersonatedUser = null;
        parsedUser.ImpersonatedUserRights = null;
        this.UserObject = new BehaviorSubject<LoginRequest>(parsedUser);
        this.UserObject.next(parsedUser);
        this.storage.setItem(this.USER, JSON.stringify(parsedUser));
      }
      this.ClearRights();
      this.SetRights(this.UserObject.value.UserRights);
      this.router.navigate(['/']);
    }
  }

  getError(error: any, router: Router): Boolean {
    // console.log( error,router.url);
    localStorage.setItem('error', error['message']);
    if (error['status'] == 403) {
      // console.log("Config found error 403", error);
      this.Logout();
      return false;
    } else if (error['status'] != 403) {
      // router.navigate(['/error']);
    }
    return false;
  }

  IsAdmin() {
    if (this.RightsObject.value['HIP'] != null) {
      if (this.RightsObject.value['HIP']['Super User'] != null) {
        return true;
      }
    }
    return false;
  }

  //Contractor Management
  IsContractor(): boolean {
    return this.UserObject?.value?.IsContractorLogin === true;
  }

  SetContractorToken(newToken: string) {
    if (this.UserObject == null) {
      // Minimal placeholder for pre-login contractor
      this.UserObject = new BehaviorSubject<LoginRequest>(
        new LoginRequest(0, 0, 0, '', '', newToken, [], true)
      );
    } else {
      this.UserObject.value.Token = newToken;
    }

    this.storage.setItem(this.USER, JSON.stringify(this.UserObject.value));
  }

  SetActiveContractor(contractorId: number) {
    if (this.UserObject && this.UserObject.value) {
      let currentUser = this.UserObject.value;
      currentUser.ContractorID = contractorId;
      // currentUser.LoggedIn = loggedIn;      // UI-specific login state for contractor context
      this.UserObject.next(currentUser);
      this.storage.setItem(this.USER, JSON.stringify(currentUser));
    }
  }

  GetContractorID(): number {
    if (this.UserObject && this.UserObject.value && this.UserObject.value.ContractorID) {
      return this.UserObject.value.ContractorID;
    }
    return 0;
  }

  NavigateBackToTakeover() {
    this.router.navigate(['/Contractors/TakeoverManagement']);
  }
}
